export type TransactionType = "expense" | "income";

export const CATEGORIES = [
  "餐饮",
  "交通",
  "购物",
  "娱乐",
  "居住",
  "医疗",
  "工资",
  "投资",
  "其他",
] as const;

export type Category = (typeof CATEGORIES)[number];

export interface Transaction {
  id: string;
  type: TransactionType;
  amount_cents: number;
  category: string;
  note: string;
  transaction_date: string;
  transaction_time: string;
  created_at: string;
  updated_at: string;
}

export type TransactionInput = Pick<
  Transaction,
  | "type"
  | "amount_cents"
  | "category"
  | "note"
  | "transaction_date"
  | "transaction_time"
>;

export interface CalendarDay {
  date: string;
  expense_cents: number;
  income_cents: number;
}

export interface CalendarResponse {
  year: number;
  month: number;
  days: CalendarDay[];
  daily_expense_limit_cents: number;
}

export interface TransactionsResponse {
  date: string;
  transactions: Transaction[];
}

export interface SettingsResponse {
  daily_expense_limit_cents: number;
}

export interface ApiErrorBody {
  error: {
    code: string;
    message: string;
    details?: Record<string, string>;
  };
}
